import axios from "@shared/services/axiosProvider";
import { AxiosProgressEvent, AxiosResponse, AxiosPromise } from "axios";
import { documentsRoot } from "./paths";
import { Paginated, PaginationQuery, convertToUrlParams } from "./common";
import { KnowledgeUnitResponse } from "./knowledgeSpaces";

export function postDocument(
  formData: FormData,
  onUploadProgress: (event: AxiosProgressEvent) => void,
  signal?: AbortSignal,
): AxiosPromise<FileCreateResponse> {
  return axios({
    method: "post",
    url: `/api/documents`,
    data: formData,
    headers: {
      "Content-Type": `multipart/form-data;`,
    },
    onUploadProgress,
    signal,
  });
}

export type FileCreateResponse = FileMetaData & {
  kUnit: KnowledgeUnitResponse;
};

export type FileMetaData = {
  uuid: string;
  created: string;
  modified: string;
  name: string;
  fileName: string;
  key: string;
  category: string;
  mimeType: string;
  size: number;
  metadata?: {
    primary?: boolean;
  };
  purpose?: string;
  parameters?: Array<string>;
  locked: boolean;
  description: string;
  type: string;
  scenario: string;
  origin: string;
  createdBy: string;
  checksum: string;
  status: "loadind" | "loaded" | "error";
  startDate: string;
  endDate: string;
};

export type DocumentsQuery = PaginationQuery &
  Partial<Record<"type" | "category" | "startDate" | "endDate", string>>;
export function getDocuments(
  query: DocumentsQuery,
): Promise<AxiosResponse<Paginated<FileMetaData>>> {
  return axios.get(`${documentsRoot}/documents?${convertToUrlParams(query)}`);
}

export type FileMetaDataPatch = {
  name?: string;
  fileName?: string;
  category?: string;
  mimeType?: string;
  metadata?: {
    primary?: boolean;
  };
  purpose?: string;
  parameters?: Array<string>;
  locked?: boolean;
  description?: string;
  type?: string;
  scenario?: string;
  origin?: string;
};
export function patchDocument(
  documentId: string,
  entity: {
    entityId: string;
    entityType: string;
  },
  patch: FileMetaDataPatch,
) {
  return axios.patch(
    `/api/documents/${documentId}?${new URLSearchParams(entity)}`,
    patch,
  );
}

export function deleteDocument(id: string) {
  return axios.delete(`${documentsRoot}/documents/${id}`);
}

export type DocumentsSearch = {
  startDate?: string;
  endDate?: string;
  type?: string;
  uuids?: string[];
  category?: string;
  entityType?: string;
  entityId?: string;
};
export function searchDocuments(
  page: PaginationQuery,
  query: DocumentsSearch,
): AxiosPromise<Paginated<FileMetaData[]>> {
  return axios.post(`/api/documents/search?${convertToUrlParams(page)}`, query);
}
